var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuToggler = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 25,
  viewBox: "0 0 32 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 1.25H30.5833H1.25ZM1.25 12.25H30.5833H1.25ZM1.25 23.25H30.5833H1.25Z",
  fill: "#4A148C"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 1.25H30.5833M1.25 12.25H30.5833M1.25 23.25H30.5833",
  stroke: "#4A148C",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgMenuToggler;